export const ONBOARDING_VERSION = 1;

export const TOUR_IDS = {
  dashboard: "dashboard",
  annotation: "annotation",
  captures: "captures",
};

const tours = {
  [TOUR_IDS.dashboard]: [
    {
      title: "Welcome to Digitomy",
      intro: "Use the options below to access your research workspace.",
    },
    {
      element: '[data-tour="dashboard-captures"]',
      title: "Review captured images",
      intro: "Browse your organization's latest trap sessions, inspect each camera view, and open full-size images.",
      position: "bottom",
    },
    {
      element: '[data-tour="dashboard-annotate"]',
      title: "Start annotating",
      intro: "Identify mosquito specimens and record the biological details used by your research team.",
      position: "bottom",
    },
    {
      element: '[data-tour="tour-help"]',
      title: "Need a refresher?",
      intro: "Use Guided tour at any time to replay the walkthrough for the page you are viewing.",
      position: "bottom-right-aligned",
    },
  ],
  [TOUR_IDS.annotation]: [
    {
      title: "Annotation walkthrough",
      intro: "Let's review the tools you will use to identify each mosquito image.",
    },
    {
      element: '[data-tour="annotation-image"]',
      title: "Inspect the specimen",
      intro: "Study the current mosquito image here before recording an identification.",
      position: "right",
    },
    {
      element: '[data-tour="annotation-zoom"]',
      title: "Zoom and pan",
      intro: "Zoom in for small features, reset to 100%, and drag the image while it is enlarged.",
      position: "bottom",
    },
    {
      element: '[data-tour="annotation-taxonomy"]',
      title: "Choose genus and species",
      intro: "Select the genus first. The species list will then show the matching choices. Use Unknown when the taxon cannot be determined.",
      position: "left",
    },
    {
      element: '[data-tour="annotation-gender"]',
      title: "Record gender",
      intro: "Choose male, female, or leave the identification as Unknown.",
      position: "left",
    },
    {
      element: '[data-tour="annotation-notes"]',
      title: "Add optional notes",
      intro: "Record observations that may help reviewers understand your identification.",
      position: "left",
    },
    {
      element: '[data-tour="annotation-other"]',
      title: "Flag unusual images",
      intro: "Use one of these options when the image contains multiple mosquitoes, a partial specimen, or no mosquito.",
      position: "left",
    },
    {
      element: '[data-tour="annotation-actions"]',
      title: "Submit or skip",
      intro: "Submit saves your annotation and loads the next image. Skip moves on without saving an answer.",
      position: "top",
    },
    {
      element: '[data-tour="annotation-progress"]',
      title: "Track your progress",
      intro: "Your completed count updates as annotations are submitted. End Session returns you safely to the dashboard.",
      position: "bottom-right-aligned",
    },
  ],
  [TOUR_IDS.captures]: [
    {
      title: "Captured images walkthrough",
      intro: "This page organizes processed trap images into capture sessions, with the newest sessions first.",
    },
    {
      element: '[data-tour="captures-summary"]',
      title: "Session summary",
      intro: "See the total number of capture sessions and the current sort order here.",
      position: "left",
    },
    {
      element: '[data-tour="capture-session"]',
      title: "Capture session",
      intro: "Each card groups the capture time, location, DNA-barcode status, and available camera images.",
      position: "bottom",
    },
    {
      element: '[data-tour="capture-cameras"]',
      title: "Camera views",
      intro: "Open a camera image in the built-in viewer, then zoom and pan to inspect the full-size version.",
      position: "top",
    },
    {
      element: '[data-tour="captures-pagination"]',
      title: "Browse older sessions",
      intro: "Use the page controls to move through earlier capture sessions.",
      position: "top",
    },
    {
      element: '[data-tour="tour-help"]',
      title: "Replay this tour",
      intro: "Use Guided tour whenever you want to see this walkthrough again.",
      position: "bottom-right-aligned",
    },
  ],
};

export const getTourSteps = (tourId) => tours[tourId] || [];
